export class UIColors {
}
UIColors.bgColor = 0x303030;
UIColors.fgColor = 0x5F5F5F;
UIColors.timelineMarkerColor = 0xEEEEEE;
UIColors.metadataEventColor = 0x0075ff;
UIColors.trackEventColor = 0x319999;
UIColors.trackEventSelectedColor = 0x004545;
UIColors.trackEventHoveredColor = 0x097272;
UIColors.trackEventDeleteColor = 0xFF0000;
UIColors.trackEventHighlightColor = 0x54b7b7;
export class UIFonts {
}
UIFonts.trackFont = {
    fontFamily: "Arial",
    fontSize: 15,
    fill: 0xFFFFFF
};
export class UIPositioning {
}
UIPositioning.timelineHeaderHeight = 40;
UIPositioning.sequencerSidebarWidth = 100;
UIPositioning.timelineSidebarWidth = 200;
//# sourceMappingURL=UITheme.js.map